import {DocumentNode, gql} from "@apollo/client";

export const PAYMENT_SIMPLE_ANALYTIC_QUERY: DocumentNode = gql(`    
    query GetPaymentSimpleAnalytic($dto: PaymentSimpleAnalyticRequest!) {
      getPaymentSimpleAnalytic(paymentSimpleAnalyticDto: $dto) {
        ...PaymentSimpleAnalytic
      }
    }
`);
